import { Session } from '@ap/interface-apic-sessiebeheer';

export const BrowserSessionName = 'tokens-browser';
export const BrowserSessionType = 'tokenData';
export const RegularRequestSession: Session = {
    authentication_level: 30
};
export const HuismaprequestSession: Session = {
    authentication_level: 20
};
export const InstantNotificationContentKey = 'ap.content.pageid_login.contentid_login_header';

export enum AriaLabels {
    IBP_ARIA = 'ibpAria',
    GENERIC_ARIA = 'genericAria',
    SHOW_SESSION_ARIA = 'showSessionAria',
    DIGICODE_HERSTEL_ARIA = 'digicodeHerstelAria'
}

export const NBA_SESSION = 'nba';
export const MIJN_OMGEVING_SESSION = 'mijn-omgeving';
export const CONVERSATIONAL_SESSION = 'mijn-conversational.chat-session';
export const OVERBOEKEN_SESSION = 'overboeken';

export const ANALYTICS_CLICKED_ELEMENT = 'browser-outdated-modal';
export const ANALYTICS_CLICKACTION_TOBROWSERPAGE = 'toBrowserPage';
export const ANALYTICS_CLICKACTION_TOLOGIN = 'toLogin';
export const NO_AVAILABLE_TOKENS_MODAL = 'no-available-tokens-modal';

export const MINIMAL_BROWSER_VERSIONS = [
    { name: 'Chrome', version: { chrome: '>145.0.0' } },
    { name: 'Microsoft Edge', version: { edge: '>146.0.0' } },
    { name: 'Firefox', version: { firefox: '>148.0.0' } }, // Use Firefox enterprise latest as version
    { name: 'Opera', version: { opera: '>129.0' } },
    { name: 'Safari', version: { safari: '>22.0' } },
    { name: 'Samsung Internet for Android', version: { samsung_internet: '>28' } }
];
